import { useCallback } from "react";
import Tooltip from "app/components/analytics/shared/Tooltips/BasicTooltip";

export type DateFilter = "1hour" | "4hours" | "1day" | "7days" | "14days" | "28days";

type Props = {
  setFilter: (DateFilter) => void;
  filter: DateFilter;
  heading?: string;
  subHeading?: string;
  className?: string;
  tooltip?: {
    name: string;
    description: string;
  };
  hideDateFilter?: boolean;
};

export const DATE_FILTERS = [
  { label: "1h", value: "1hour" },
  { label: "4h", value: "4hours" },
  { label: "1d", value: "1day" },
  { label: "7d", value: "7days" },
  { label: "14d", value: "14days" },
  { label: "28d", value: "28days" },
];

if (Features.AnalyticsTagging90DaysView) {
  DATE_FILTERS.push({ label: "90d", value: "90days" });
}

const DateFilters = ({
  className,
  heading,
  subHeading,
  tooltip,
  filter,
  hideDateFilter,
  setFilter,
}: Props) => (
  <div
    className={`${className} justify-between flex max-[486px]:flex-col max-[486px]:items-start min-[487px]:items-center`}
  >
    {heading && <h2 className="mt-4 charcoal-700 text-lg">{heading}</h2>}

    {subHeading && (
      <div className="flex items-center">
        <h3 className="charcoal-700 text-sm">{subHeading}</h3>
        {tooltip && (
          <Tooltip classNames="ml-2" name={tooltip.name}>
            <>
              <p className="font-semibold m-0">{subHeading}</p>
              <p className="m-0 mt-1" dangerouslySetInnerHTML={{ __html: tooltip.description }} />
            </>
          </Tooltip>
        )}
      </div>
    )}

    {!hideDateFilter && (
      <div className="border border-gray-500 bg-white rounded p-0.5 inline-flex">
        {DATE_FILTERS.map((dateFilter) => {
          const isActive = filter === dateFilter.value;
          const handleClick = useCallback(() => setFilter(dateFilter.value), []);

          return (
            <button
              key={dateFilter.value}
              onClick={handleClick}
              className={`px-2.5 py-1 text-charcoal-700 font-medium rounded-sm flex items-center text-sm cursor-pointer hover:text-purple-600 hover:no-underline focus:no-underline focus:text-charcoal-700 focus:ring-2 focus:ring-offset-2 focus:ring-lime-500 focus:outline-none ${isActive ? "bg-purple-100 text-purple-600 focus:text-purple-600" : ""}`}
            >
              {dateFilter.label}
            </button>
          );
        })}
      </div>
    )}
  </div>
);

export default DateFilters;
